import { DialogActions, DialogTitle, Icon, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import CustomDialog from 'components/custom/CustomDialog';
import { CustomButton } from 'components/roundedbutton/CustomButton';
import { IAbstractModel } from 'model/abstract.model';

import { IProduto } from './registra-venda.model';
import { theme } from 'theme';

export type DialogConfirmacaoExcluirSku = {
    showConfirmaExclusao: boolean,
    produtosParaExcluir: string[],
    tabelaPrecoTemp: IAbstractModel | null,
    data: IProduto[],
    length: number;
};

type Props = {
    open: boolean;
    dados: DialogConfirmacaoExcluirSku;
    onConfirm: () => void;
    onCancel?: () => void | undefined;
};

const ConfirmacaoExcluirSkuDialog = (props: Props) => {
    return (
        <CustomDialog open={props.open} fullWidth onClose={props.onCancel}>
            <DialogTitle sx={{ border: 0, margin: 0, padding: 0 }} align="center">
                PRODUTOS NÃO ENCONTRADO NA TABELA
            </DialogTitle>
            <DialogTitle sx={{ border: 0, margin: 0, padding: 0, fontWeight: 'bold' }} align="center">
                {props.dados.tabelaPrecoTemp?.descritivo ?? 'Tabela de Preço '}
            </DialogTitle>
            <TableContainer
                sx={{
                    backgroundColor: theme.palette.background.default,
                    borderRadius: 1,
                    position: 'relative',
                    boxSizing: 'border-box',
                    maxHeight: '400px',
                    padding: '5px'
                }}
                className="color-orange">
                <Table id="modal-show-confirmacao-exclusao-table">
                    <TableBody sx={{ textAlign: 'center' }}>
                        {props.dados.produtosParaExcluir.map((e, index) => (
                            <TableRow key={'sku' + index} >
                                <TableCell sx={{ color: theme.palette.common.black }}>
                                    {e}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <DialogActions sx={{
                justifyContent: props.onCancel ? 'space-between' : 'center',
                marginTop: '20px'
            }}>
                {props.onCancel && <CustomButton onClick={props.onCancel} variant="contained" color="error" startIcon={<Icon className="fa-solid fa-xmark" />}>
                    Cancelar
                </CustomButton>}

                <CustomButton onClick={props.onConfirm} variant="contained" color="success" startIcon={<Icon className="fa-solid fa-check" />}>
                    Confirmar
                </CustomButton>
            </DialogActions>
        </CustomDialog>
    );
};

export default ConfirmacaoExcluirSkuDialog;
